export default __webpack_public_path__ + "static/media/control-left-light-1.bf3eb853.svg";